module.exports = __webpack_public_path__ + "static/media/7.f78f3bb9.jpg";